import {Evaluator} from "@cm/graph-v3"
import {registerImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/register-image-op-node"
import {ImageOpContextImgProc} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-context-imgproc"
import {assertNoBatching} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/utils/image-op-utils"
import {createImageOpImgProc} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/imgproc/image-op-imgproc-utils"
import {definition} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/reduce/definition"
import {ImageOpReduceHal} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/reduce/hal"
import {determineDescriptor} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/reduce/helpers"
import {ImageOpParametersOfType} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/specializing-image-op-node"
import {ImageOpInputsOrNodes} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {BasicSpecializingImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/basic-specializing-image-op-node"

const nodeDefinition = {...definition, nodeClass: "ImageOpNodeReduce"}

@registerImageOpNode
export class ImageOpNodeReduce extends BasicSpecializingImageOpNode<typeof definition, ImageOpReduceHal> {
    override get definition() {
        return nodeDefinition
    }

    constructor(parameters: ImageOpInputsOrNodes<typeof definition>) {
        super(ImageOpReduceHal, parameters)
    }

    override toImgProc = async (evaluator: Evaluator<ImageOpContextImgProc>, parameters: ImageOpParametersOfType<typeof definition, "imgproc">) => {
        const evaluatedParameters = await evaluator.getAll(parameters)
        if (evaluatedParameters.operator === "custom") {
            throw new Error("Custom reduce operator is not supported in ImgProc")
        }
        assertNoBatching(evaluatedParameters.sourceImage.descriptor)
        return createImageOpImgProc(determineDescriptor(evaluatedParameters.sourceImage.descriptor, evaluatedParameters.custom?.reduce.resultChannels), {
            type: "reduce",
            operation: evaluatedParameters.operator,
            input: evaluatedParameters.sourceImage.node,
        })
    }
}
